// Google sign-in UI translations. The official Google button receives the
// matching locale separately in the login page.
export default {
  en: {
    or: "or",
    processing: "Verifying your Google account…",
    configMissing: "Google sign-in has not been configured",
    unavailable: "Google sign-in is temporarily unavailable",
    failed: "Google sign-in failed. Please try again",
    invalidResponse: "The login service did not return a valid credential",
    success: "Signed in with Google",
    inviteTitle: "Enter invitation code",
    inviteDescription: "This Google account is signing in for the first time. Enter a valid invitation code to create your account. Future sign-ins will continue directly.",
    cancel: "Cancel",
    continue: "Continue"
  },
  "zh-CN": {
    or: "或",
    processing: "正在验证 Google 账号…",
    configMissing: "Google 登录尚未配置，请联系管理员",
    unavailable: "Google 登录暂时不可用，请稍后重试",
    failed: "Google 登录失败，请稍后重试",
    invalidResponse: "登录服务未返回有效凭证",
    success: "Google 登录成功",
    inviteTitle: "填写邀请码",
    inviteDescription: "这是该 Google 账号首次登录，请填写有效邀请码完成开户。以后使用同一 Google 账号可直接进入。",
    cancel: "取消",
    continue: "继续进入"
  },
  ko: {
    or: "또는",
    processing: "Google 계정을 확인하는 중…",
    configMissing: "Google 로그인이 구성되지 않았습니다",
    unavailable: "Google 로그인을 일시적으로 사용할 수 없습니다",
    failed: "Google 로그인에 실패했습니다. 다시 시도해 주세요",
    invalidResponse: "로그인 서비스가 유효한 인증 정보를 반환하지 않았습니다",
    success: "Google로 로그인했습니다",
    inviteTitle: "초대 코드 입력",
    inviteDescription: "이 Google 계정은 처음 로그인합니다. 유효한 초대 코드를 입력하여 계정을 만드세요. 다음부터는 바로 로그인됩니다.",
    cancel: "취소",
    continue: "계속"
  },
  jp: {
    or: "または",
    processing: "Google アカウントを確認しています…",
    configMissing: "Google ログインが設定されていません",
    unavailable: "Google ログインは一時的に利用できません",
    failed: "Google ログインに失敗しました。もう一度お試しください",
    invalidResponse: "ログインサービスから有効な認証情報が返されませんでした",
    success: "Google でログインしました",
    inviteTitle: "招待コードを入力",
    inviteDescription: "この Google アカウントでの初回ログインです。有効な招待コードを入力してアカウントを作成してください。次回からは直接ログインできます。",
    cancel: "キャンセル",
    continue: "続ける"
  },
  vi: {
    or: "hoặc",
    processing: "Đang xác minh tài khoản Google…",
    configMissing: "Đăng nhập bằng Google chưa được cấu hình",
    unavailable: "Đăng nhập bằng Google tạm thời không khả dụng",
    failed: "Đăng nhập bằng Google thất bại. Vui lòng thử lại",
    invalidResponse: "Dịch vụ đăng nhập không trả về thông tin xác thực hợp lệ",
    success: "Đã đăng nhập bằng Google",
    inviteTitle: "Nhập mã mời",
    inviteDescription: "Đây là lần đăng nhập đầu tiên của tài khoản Google này. Hãy nhập mã mời hợp lệ để tạo tài khoản. Những lần sau bạn sẽ được đăng nhập trực tiếp.",
    cancel: "Hủy",
    continue: "Tiếp tục"
  },
  hi: {
    or: "या",
    processing: "Google खाते की पुष्टि की जा रही है…",
    configMissing: "Google साइन-इन कॉन्फ़िगर नहीं किया गया है",
    unavailable: "Google साइन-इन अस्थायी रूप से उपलब्ध नहीं है",
    failed: "Google साइन-इन विफल रहा। कृपया फिर प्रयास करें",
    invalidResponse: "लॉगिन सेवा ने मान्य क्रेडेंशियल नहीं लौटाया",
    success: "Google से साइन इन हो गया",
    inviteTitle: "आमंत्रण कोड दर्ज करें",
    inviteDescription: "यह इस Google खाते का पहला लॉगिन है। खाता बनाने के लिए मान्य आमंत्रण कोड दर्ज करें। अगली बार आप सीधे लॉगिन कर सकेंगे।",
    cancel: "रद्द करें",
    continue: "जारी रखें"
  },
  th: {
    or: "หรือ",
    processing: "กำลังตรวจสอบบัญชี Google…",
    configMissing: "ยังไม่ได้ตั้งค่าการเข้าสู่ระบบด้วย Google",
    unavailable: "การเข้าสู่ระบบด้วย Google ไม่พร้อมใช้งานชั่วคราว",
    failed: "เข้าสู่ระบบด้วย Google ไม่สำเร็จ โปรดลองอีกครั้ง",
    invalidResponse: "บริการเข้าสู่ระบบไม่ได้ส่งข้อมูลรับรองที่ถูกต้องกลับมา",
    success: "เข้าสู่ระบบด้วย Google สำเร็จ",
    inviteTitle: "กรอกรหัสเชิญ",
    inviteDescription: "นี่เป็นการเข้าสู่ระบบครั้งแรกของบัญชี Google นี้ โปรดกรอกรหัสเชิญที่ถูกต้องเพื่อสร้างบัญชี ครั้งต่อไปคุณจะเข้าสู่ระบบได้โดยตรง",
    cancel: "ยกเลิก",
    continue: "ดำเนินการต่อ"
  },
  ru: {
    or: "или",
    processing: "Проверяем аккаунт Google…",
    configMissing: "Вход через Google не настроен",
    unavailable: "Вход через Google временно недоступен",
    failed: "Не удалось войти через Google. Повторите попытку",
    invalidResponse: "Сервис входа не вернул действительные учетные данные",
    success: "Вход через Google выполнен",
    inviteTitle: "Введите код приглашения",
    inviteDescription: "Это первый вход с данного аккаунта Google. Введите действительный код приглашения, чтобы создать аккаунт. В дальнейшем вход будет выполняться напрямую.",
    cancel: "Отмена",
    continue: "Продолжить"
  },
  es: {
    or: "o",
    processing: "Verificando tu cuenta de Google…",
    configMissing: "El inicio de sesión con Google no está configurado",
    unavailable: "El inicio de sesión con Google no está disponible temporalmente",
    failed: "No se pudo iniciar sesión con Google. Inténtalo de nuevo",
    invalidResponse: "El servicio de acceso no devolvió una credencial válida",
    success: "Has iniciado sesión con Google",
    inviteTitle: "Introduce el código de invitación",
    inviteDescription: "Es el primer acceso de esta cuenta de Google. Introduce un código de invitación válido para crear tu cuenta. En los próximos accesos entrarás directamente.",
    cancel: "Cancelar",
    continue: "Continuar"
  },
  fr: {
    or: "ou",
    processing: "Vérification de votre compte Google…",
    configMissing: "La connexion avec Google n’est pas configurée",
    unavailable: "La connexion avec Google est temporairement indisponible",
    failed: "La connexion avec Google a échoué. Veuillez réessayer",
    invalidResponse: "Le service de connexion n’a pas renvoyé d’identifiant valide",
    success: "Connexion avec Google réussie",
    inviteTitle: "Saisissez le code d’invitation",
    inviteDescription: "Il s’agit de la première connexion de ce compte Google. Saisissez un code d’invitation valide pour créer votre compte. Les prochaines connexions seront directes.",
    cancel: "Annuler",
    continue: "Continuer"
  },
  de: {
    or: "oder",
    processing: "Google-Konto wird überprüft…",
    configMissing: "Google-Anmeldung ist nicht konfiguriert",
    unavailable: "Google-Anmeldung ist vorübergehend nicht verfügbar",
    failed: "Google-Anmeldung fehlgeschlagen. Bitte erneut versuchen",
    invalidResponse: "Der Anmeldedienst hat keine gültigen Zugangsdaten zurückgegeben",
    success: "Mit Google angemeldet",
    inviteTitle: "Einladungscode eingeben",
    inviteDescription: "Dieses Google-Konto meldet sich zum ersten Mal an. Geben Sie einen gültigen Einladungscode ein, um Ihr Konto zu erstellen. Künftige Anmeldungen erfolgen direkt.",
    cancel: "Abbrechen",
    continue: "Weiter"
  },
  it: {
    or: "oppure",
    processing: "Verifica dell’account Google…",
    configMissing: "L’accesso con Google non è configurato",
    unavailable: "L’accesso con Google è temporaneamente non disponibile",
    failed: "Accesso con Google non riuscito. Riprova",
    invalidResponse: "Il servizio di accesso non ha restituito credenziali valide",
    success: "Accesso con Google effettuato",
    inviteTitle: "Inserisci il codice di invito",
    inviteDescription: "Questo è il primo accesso di questo account Google. Inserisci un codice di invito valido per creare l’account. Gli accessi successivi saranno diretti.",
    cancel: "Annulla",
    continue: "Continua"
  }
};
